import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card } from '../components/ui/Card';
import { PiggyBankIcon, TrendingUpIcon, PlusIcon, CalendarIcon } from 'lucide-react';
export function Savings() {
  return <div data-id="element-503">
      <PageHeader title="Savings" description="Grow your money with our savings options" data-id="element-504" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-505">
        <div className="lg:col-span-2" data-id="element-506">
          <Card title="My Savings" data-id="element-507">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-508">
              <div className="bg-gradient-to-r from-green-500 to-green-700 rounded-xl p-6 text-white shadow-lg" data-id="element-509">
                <div className="flex justify-between items-start" data-id="element-510">
                  <div data-id="element-511">
                    <p className="text-sm opacity-80" data-id="element-512">Total Savings</p>
                    <p className="text-3xl font-bold" data-id="element-513">$12,450.25</p>
                    <p className="text-sm mt-2" data-id="element-514">+$450.25 this month</p>
                  </div>
                  <div data-id="element-515">
                    <PiggyBankIcon className="h-10 w-10" data-id="element-516" />
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-r from-blue-500 to-blue-700 rounded-xl p-6 text-white shadow-lg" data-id="element-517">
                <div className="flex justify-between items-start" data-id="element-518">
                  <div data-id="element-519">
                    <p className="text-sm opacity-80" data-id="element-520">Interest Earned</p>
                    <p className="text-3xl font-bold" data-id="element-521">$320.80</p>
                    <p className="text-sm mt-2" data-id="element-522">5.2% Annual Interest</p>
                  </div>
                  <div data-id="element-523">
                    <TrendingUpIcon className="h-10 w-10" data-id="element-524" />
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-6" data-id="element-525">
              <h3 className="text-lg font-medium mb-4" data-id="element-526">Savings Plans</h3>
              <div className="space-y-4" data-id="element-527">
                {[{
                name: 'Emergency Fund',
                balance: '$5,000.00',
                goal: '$10,000.00',
                progress: 50
              }, {
                name: 'Vacation',
                balance: '$2,500.00',
                goal: '$5,000.00',
                progress: 50
              }, {
                name: 'New Car',
                balance: '$4,950.25',
                goal: '$15,000.00',
                progress: 33
              }].map((plan, i) => <div key={i} className="border rounded-lg p-4" data-id="element-528">
                    <div className="flex justify-between items-center mb-2" data-id="element-529">
                      <h4 className="font-medium" data-id="element-530">{plan.name}</h4>
                      <span className="text-sm bg-green-100 text-green-800 px-2 py-1 rounded-full" data-id="element-531">
                        Active
                      </span>
                    </div>
                    <div className="flex justify-between mb-2" data-id="element-532">
                      <span className="text-sm text-gray-500" data-id="element-533">Balance</span>
                      <span className="text-sm font-medium" data-id="element-534">
                        {plan.balance}
                      </span>
                    </div>
                    <div className="flex justify-between mb-2" data-id="element-535">
                      <span className="text-sm text-gray-500" data-id="element-536">Goal</span>
                      <span className="text-sm font-medium" data-id="element-537">{plan.goal}</span>
                    </div>
                    <div className="mt-3" data-id="element-538">
                      <div className="flex justify-between mb-1" data-id="element-539">
                        <span className="text-xs font-medium text-gray-700" data-id="element-540">
                          {plan.progress}% Complete
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-541">
                        <div className="bg-green-600 h-2 rounded-full" style={{
                      width: `${plan.progress}%`
                    }} data-id="element-542"></div>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </Card>
        </div>
        <div data-id="element-543">
          <Card title="Create Savings Plan" data-id="element-544">
            <form className="space-y-4" data-id="element-545">
              <div data-id="element-546">
                <label htmlFor="planName" className="block text-sm font-medium text-gray-700" data-id="element-547">
                  Plan Name
                </label>
                <input type="text" name="planName" id="planName" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="e.g. New Home" data-id="element-548" />
              </div>
              <div data-id="element-549">
                <label htmlFor="goalAmount" className="block text-sm font-medium text-gray-700" data-id="element-550">
                  Goal Amount
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-551">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-552">
                    <span className="text-gray-500 sm:text-sm" data-id="element-553">$</span>
                  </div>
                  <input type="text" name="goalAmount" id="goalAmount" className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" data-id="element-554" />
                </div>
              </div>
              <div data-id="element-555">
                <label htmlFor="targetDate" className="block text-sm font-medium text-gray-700" data-id="element-556">
                  Target Date
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-557">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-558">
                    <CalendarIcon className="h-5 w-5 text-gray-400" data-id="element-559" />
                  </div>
                  <input type="date" name="targetDate" id="targetDate" className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" data-id="element-560" />
                </div>
              </div>
              <div data-id="element-561">
                <label htmlFor="initialDeposit" className="block text-sm font-medium text-gray-700" data-id="element-562">
                  Initial Deposit
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-563">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-564">
                    <span className="text-gray-500 sm:text-sm" data-id="element-565">$</span>
                  </div>
                  <input type="text" name="initialDeposit" id="initialDeposit" className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" data-id="element-566" />
                </div>
              </div>
              <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-567">
                <PlusIcon className="mr-2 h-5 w-5" data-id="element-568" />
                Create Savings Plan
              </button>
            </form>
          </Card>
          <Card title="Savings Rates" className="mt-6" data-id="element-569">
            <div className="space-y-4" data-id="element-570">
              {[{
              plan: 'Regular Savings',
              rate: '3.5%',
              min: '$0'
            }, {
              plan: 'Fixed Deposit',
              rate: '5.2%',
              min: '$1,000'
            }, {
              plan: 'Goal-Based Savings',
              rate: '4.8%',
              min: '$500'
            }, {
              plan: 'High-Yield Savings',
              rate: '6.0%',
              min: '$5,000'
            }].map((saving, i) => <div key={i} className="flex justify-between items-center border-b pb-2 last:border-b-0 last:pb-0" data-id="element-571">
                  <div data-id="element-572">
                    <p className="font-medium" data-id="element-573">{saving.plan}</p>
                    <p className="text-xs text-gray-500" data-id="element-574">Min. {saving.min}</p>
                  </div>
                  <div className="text-right" data-id="element-575">
                    <p className="text-lg font-semibold text-green-600" data-id="element-576">
                      {saving.rate}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-577">Annual</p>
                  </div>
                </div>)}
            </div>
          </Card>
        </div>
      </div>
    </div>;
}